import { ALL_PROVIDERS_INVITES_SUCCESS, RESET_INVITES } from "../action.types";
import InitialState from "../initial.state";

export default (state = InitialState.agentsSelected, action) => {
  switch (action.type) {
    case ALL_PROVIDERS_INVITES_SUCCESS:
      return action.payload.values;
    case RESET_INVITES:
      return InitialState.agentsSelected;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/providerSelected/agentSelected.reducer.js